import { Content } from "@/ui/Content";
import * as additionalComponents from "@/components/RecruitmentPage";
import { router } from "@/router";
import { stripTags } from "@/functions/stripTags";
import { getGlobal } from "@/functions/getGlobal";
import sourceflowEnums from "@/sourceflow.enums";

export default function Page({ content }) {
  return (
    <>
      <Content items={content} additionalComponents={additionalComponents} />
    </>
  );
}

export async function getStaticProps({}) {
  const global = getGlobal();
  const type = sourceflowEnums.config.recruitmentTypes.permanent;
  const routerProp = router[`hiring.${type}`];
  const titleKey = `page.${type}.banner.title`;

  return {
    props: {
      meta: {
        en: {
          title: stripTags(global[`${titleKey}.en`]),
          canonical: `${sourceflowEnums.config.baseUrl}${routerProp["en"]}`,
        },
      },
      router: routerProp,
      content: [
        { component: "RecruitmentPageBannerSection", props: { type } },
        { component: "RecruitmentPageContentSection", props: { type } },
        { component: "ExpectationsSection", props: { type } },
        { component: "RecruitmentProcessSection", props: { type } },
      ],
    },
  };
}
